import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Send, Building2 } from "lucide-react";

const BAR_TIERS = [20, 50, 100, 250];

export default function Wholesale() {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({
    company: "", contact_name: "", email: "", phone: "",
    country: "CY", bar_count: 50, frequency: "one-off", notes: "",
  });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/business/quote", { ...form, bar_count: parseInt(form.bar_count) });
      toast.success("Enquiry sent · we'll reply within 1 business day");
      nav("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Send failed");
    } finally { setBusy(false); }
  };
  const input = "w-full px-4 py-3 rounded-lg border border-[color:var(--brunchi-stone-2)] bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[color:var(--brunchi-green)]";
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="wholesale-page">
      <div className="text-xs uppercase tracking-[0.25em] text-[color:var(--brunchi-green-hover)] mb-3">Bulk & offices</div>
      <h1 className="font-display text-4xl lg:text-5xl tracking-tight">Brunchi for teams.</h1>
      <p className="mt-3 text-[color:var(--brunchi-ink-soft)]">
        Corporate breakfast, office pantries, event goody bags, hotel amenities — from 20 bars to 2,000.
        Tell us what you need; we'll come back with pricing and a delivery plan within a business day.
      </p>
      <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-2">
        {BAR_TIERS.map((n) => (
          <button key={n} type="button" onClick={() => setForm({ ...form, bar_count: n })}
            data-testid={`bulk-tier-${n}`}
            className={`py-3 rounded-lg border-2 font-mono font-semibold ${
              parseInt(form.bar_count) === n
                ? "border-[color:var(--brunchi-green)] bg-[color:var(--brunchi-green-light)] text-[color:var(--brunchi-green-hover)]"
                : "border-[color:var(--brunchi-stone-2)] bg-white"
            }`}>
            {n} bars
          </button>
        ))}
      </div>
      <form onSubmit={submit} className="mt-6 space-y-3" data-testid="wholesale-form">
        <div className="grid sm:grid-cols-2 gap-3">
          <input required placeholder="Company / organisation" value={form.company}
            onChange={(e) => setForm({ ...form, company: e.target.value })} className={input} data-testid="bulk-company" />
          <input required placeholder="Your name" value={form.contact_name}
            onChange={(e) => setForm({ ...form, contact_name: e.target.value })} className={input} data-testid="bulk-contact" />
          <input required type="email" placeholder="Email" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="bulk-email" />
          <input placeholder="Phone (optional)" value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })} className={input} data-testid="bulk-phone" />
          <select value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} className={input} data-testid="bulk-country">
            <option value="CY">Cyprus</option><option value="GR">Greece</option><option value="OTHER">Other</option>
          </select>
          <select value={form.frequency} onChange={(e) => setForm({ ...form, frequency: e.target.value })} className={input} data-testid="bulk-frequency">
            <option value="one-off">One-off</option><option value="monthly">Monthly</option>
            <option value="weekly">Weekly</option><option value="bimonthly">Every 2 months</option>
          </select>
          <input type="number" min="20" placeholder="Bar count" value={form.bar_count}
            onChange={(e) => setForm({ ...form, bar_count: e.target.value })} className={`${input} sm:col-span-2`} data-testid="bulk-count" />
          <textarea placeholder="Anything else we should know?" value={form.notes} rows={3}
            onChange={(e) => setForm({ ...form, notes: e.target.value })} className={`${input} sm:col-span-2`} data-testid="bulk-notes" />
        </div>
        <button disabled={busy} type="submit"
          data-testid="bulk-submit-btn"
          className="w-full py-3.5 rounded-full pill-primary font-medium inline-flex items-center justify-center gap-2 disabled:opacity-40">
          <Building2 size={16} /> {busy ? "Sending…" : "Request a quote"}
        </button>
      </form>
    </div>
  );
}
